import { Modal, ModalHeader, ModalHeaderWithActions, Icon } from '@evertrue/et-components';
import ThankviewRecorder from '../thankview-recorder';
import ThankviewLibrary from '../thankview-library';
import { useRecorder } from '../hooks/recorder-context';
import ThankviewDefaultSettings from '../thankview-default-settings';
import useUserAuthentication from '../hooks/useUserAuthentication';
import { useEffect, useState } from 'react';
import { useThankviewSettingsContext } from '../hooks/thankview-settings-context';

const modalTitle = Object.freeze({
  recorder: 'Record New Video',
  library: 'Video Library',
  settings: 'Your Settings',
  review: 'Review Video',
});

const SignalVideoController = () => {
  const { modalView, handleCloseThankviewModal, isThankviewModalOpen, setModalView, updateState } = useRecorder();
  const { clientId } = useUserAuthentication();
  const [view, setView] = useState(modalView);
  const { defaultUserSettings } = useThankviewSettingsContext();
  const [isModalSubmitDisabled, setIsModalSubmitDisabled] = useState(false);

  useEffect(() => {
    if (defaultUserSettings.created_at === defaultUserSettings.updated_at) {
      setView('settings');
    } else setView(modalView);
  }, [clientId, modalView, defaultUserSettings]);

  return (
    <Modal isOpen={isThankviewModalOpen} closeModal={handleCloseThankviewModal} size={'dynamic'}>
      {view === 'settings' || view === 'library' ? (
        <ModalHeaderWithActions
          closeModal={handleCloseThankviewModal}
          title={modalTitle[modalView]}
          onSubmit={() => {
            setModalView('recorder');
            updateState({ videoUrl: '' });
          }}
          submitLabel={
            view === 'settings' ? (
              'Confirm'
            ) : (
              <>
                <Icon icon="tv-video" iconKit="tv" className="tv-btn-icon" />
                New Video
              </>
            )
          }
          disableSubmit={isModalSubmitDisabled}
        />
      ) : (
        <ModalHeader closeModal={handleCloseThankviewModal} title={modalTitle[view]} />
      )}
      {view === 'library' ? (
        <ThankviewLibrary />
      ) : view === 'recorder' || view === 'review' ? (
        <ThankviewRecorder />
      ) : (
        <ThankviewDefaultSettings setIsModalSubmitDisabled={setIsModalSubmitDisabled} />
      )}
    </Modal>
  );
};

export default SignalVideoController;
